module.exports = __webpack_public_path__ + "static/media/event_home_white.ef3ad9b7.svg";